import { useEffect } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { emptyRisorse } from "./fields";

const risorseFromRequest = (ev) => {
  const risorse = emptyRisorse();
  Object.keys(risorse).forEach((k) => {
    if (ev.risorse && ev.risorse[k]) risorse[k] = { enabled: !!ev.risorse[k].enabled, qty: ev.risorse[k].qty || 1 };
  });
  return risorse;
};

const risorseFromPreventivo = (unita) => {
  const risorse = emptyRisorse();
  Object.entries(unita || {}).forEach(([k, n]) => { if (risorse[k] && Number(n) > 0) risorse[k] = { enabled: true, qty: Number(n) }; });
  return risorse;
};

// Precompila il form da: evento esistente (modifica), evento da duplicare, o preventivo evento.
export const useEventoPrefill = ({ id, duplicaId, preventivoId, isEdit, setters }) => {
  const { setEditCode, setMode, setDupCode, setAssigned, setEvento, setContabilita, setRichiedente } = setters;

  useEffect(() => {
    const srcId = isEdit ? id : duplicaId;
    if (!srcId) return;
    api.get(`/requests/${srcId}`).then(({ data }) => {
      if (isEdit) { setEditCode(data.code || ""); setMode(data.engagement_mode || "fcfs"); }
      else {
        setDupCode(data.code || "");
        setMode(data.engagement_mode === "direct" ? "fcfs" : (data.engagement_mode || "fcfs"));
        toast.info(`Evento ${data.code} duplicato`, { description: "Controlla le date prima di pubblicare: verrà assegnato un nuovo numero di servizio." });
      }
      setAssigned(data.status !== "pubblicata");
      const ev = data.evento || {};
      setEvento({
        denominazione: ev.denominazione || "", tipo: ev.tipo || "", luogo: ev.luogo || "",
        data_ora_inizio: ev.data_ora_inizio || "", data_ora_fine: ev.data_ora_fine || "",
        risorse: risorseFromRequest(ev), luogo_stazionamento: ev.luogo_stazionamento || "",
        referente: ev.referente || "", telefono_referente: ev.telefono_referente || "",
        referente_nexus: isEdit ? (ev.referente_nexus || data.operative?.referente || "") : (ev.referente_nexus || ""),
      });
      setContabilita((c) => ({ ...c, ...(data.contabilita || {}) }));
      setRichiedente(data.operative?.provenienza || "");
    }).catch(() => toast.error("Impossibile caricare l'evento"));
  }, [id, isEdit, duplicaId, setEditCode, setMode, setDupCode, setAssigned, setEvento, setContabilita, setRichiedente]);

  useEffect(() => {
    if (!preventivoId || isEdit) return;
    api.get(`/amministrazione/preventivi-eventi/${preventivoId}`).then(({ data: pv }) => {
      setEvento((e) => ({ ...e, denominazione: pv.denominazione || "", luogo: pv.luogo?.indirizzo || "", data_ora_inizio: pv.inizio || "", data_ora_fine: pv.fine || "",
        risorse: risorseFromPreventivo(pv.unita), referente: pv.cliente?.nominativo || "", telefono_referente: pv.cliente?.telefono || "" }));
      setRichiedente(pv.cliente?.nominativo || "");
      const tot = pv.calcolo?.totale;
      setContabilita((c) => ({ ...c, importo: String(tot ?? ""), fee_nexus: tot != null ? (tot * 0.15).toFixed(2) : "", note: `Da preventivo ${pv.codice}${pv.note ? ` — ${pv.note}` : ""}` }));
      toast.info(`Dati precompilati dal preventivo ${pv.codice}`, { description: "Controlla risorse e orari, poi pubblica l'evento." });
    }).catch(() => toast.error("Impossibile caricare il preventivo evento"));
  }, [preventivoId, isEdit, setEvento, setContabilita, setRichiedente]);
};
